import {APP_INITIALIZER, NgModule } from '@angular/core';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';

import { AppComponent } from './app.component';
import { CustomHttpInterceptor } from './utilities/CustomHttpInterceptor';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { UtilitiesService } from './utilities/utilities.service';
import { LanguageSwitchService } from './services/language-switch.service';
import { AlertService } from './services/alert.service';
import { SubjectService } from './services/subject.service';
import { GoogleMapsModule } from '@angular/google-maps';
import { TooltipsModule } from 'ionic4-tooltips';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ContactService } from './services/contact.service';
import { UserInfoService } from './services/user-info.service';
import { CartService } from './services/cart.service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { AgmCoreModule } from '@agm/core';
import { CheckoutService } from './services/checkout.service';
import { PaymentInfoService } from './services/payment-info.service';
import { SmilePointsService } from './services/smile-points.service';
import { AlertMessageComponent } from './shared/alert-message/alert-message.component';
import { AlertComponent } from './directives/alert/alert.component';
import { environment } from 'src/environments/environment';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { CfmViewFormService } from './services/cfm-view-form.service';
import { ProductService } from './services/product.service';
import { SeperatePipe } from './pipes/seperate.pipe';
import { RelativeDatePipe } from './pipes/relative-date.pipe';
import { NgIdleModule } from '@ng-idle/core';
import { SamplePurchaseComponent } from './sample-purchase/sample-purchase.component';
import { ApplicationInitializationService } from './services/application-initialization.service';
import { AppCmsUrlsInitializationService } from './services/app-cms-urls-initialization.service';
import { LayoutsModule } from './layouts/layouts.module';
declare module "@angular/core" {
  interface ModuleWithProviders<T = any> {
    ngModule: Type<T>;
    providers?: Provider[];
  }
}
import { AdobeAnalyticsService } from './services/adobe-analytics.service';
import { EsimModule } from './esim/esim.module';
import { ApplicationErrorCodesInitializationService } from './services/application-error-codes-initialization.service';
@NgModule({
  declarations: [AppComponent,AlertComponent, SamplePurchaseComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    IonicModule.forRoot(),
    HttpClientModule,
    LoadingBarRouterModule,
    LoadingBarHttpClientModule,
    SharedModule,
    GoogleMapsModule,
    BrowserAnimationsModule,
    GooglePlaceModule,
    EsimModule,
    NgIdleModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    TooltipsModule.forRoot(),
    AgmCoreModule.forRoot({
      libraries: ['places', 'visualization', 'drawing', 'geometry', 'places']
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    LayoutsModule
  ],
  providers: [
    { 
      provide : APP_INITIALIZER, 
      multi : true, 
      deps : [ApplicationInitializationService], 
      useFactory : (applicationInitializationService : ApplicationInitializationService) => () => applicationInitializationService.initializeApp()
    },
    { 
      provide : APP_INITIALIZER, 
      multi : true, 
      deps : [AppCmsUrlsInitializationService], 
      useFactory :(appCmsUrlsInitializationService : AppCmsUrlsInitializationService) => () => appCmsUrlsInitializationService.appCmsUrlsInitialization()
    },
    { 
      provide : APP_INITIALIZER, 
      multi : true, 
      deps : [ApplicationErrorCodesInitializationService], 
      useFactory :(applicationErrorCodesInitializationService : ApplicationErrorCodesInitializationService) => () => applicationErrorCodesInitializationService.errorCodeInitialization(),
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
    { provide: 'googleTagManagerId', useValue: environment.GTM},
    UtilitiesService,
    LanguageSwitchService,
    AlertService,
    SubjectService,
    ContactService,
    UserInfoService,
    CartService,
    CheckoutService,
    PaymentInfoService,
    SmilePointsService,
    GoogleAnalyticsService,
    AdobeAnalyticsService,
    CfmViewFormService,
    ProductService,
      SeperatePipe,
      RelativeDatePipe
    ],
  bootstrap: [AppComponent],
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, environment.TRANSLATION_URL,'.json');
  // return new TranslateHttpLoader(http);
}
